import { language as lan_storeProduct } from "./store-product/index";
import { language as lan_storeOrders } from "./store-orders/index";
import { language as lan_storeOrderDetail } from "./store-order-detail/index";
import { language as lan_standardOrders } from "./standard-orders/index";
import { language as lan_standardOrderDetail } from "./standard-order-detail/index";
import { language as lan_bulkOrderList } from "./bulk-order-list/index";
import { language as lan_bulkOrderCheckout } from "./bulk-order-checkout/index";
import { language as lan_fileLibrary } from "./file-library/index";
import { language as lan_pcResourceSetting } from "./pc-resource-lib-setting/index";
import { language as lan_orders } from "./orders/index";
import { language as lan_ordersDetail } from "./order-detail/index";
import { language as lan_returns } from "./returns/index";
import { language as lan_returnRequest } from "./return-request/index";
import { language as lan_returnDetail } from "./return-detail/index";
import { language as lan_dashboardGuide } from "./dashboard-guide/index";
import { language as lan_combineOrder } from "./combine-order/index";

let language = {
    // 店铺产品
    ...lan_storeProduct,
    // 店铺订单列表
    ...lan_storeOrders,
    // 店铺订单详情
    ...lan_storeOrderDetail,
    // 标准单列表
    ...lan_standardOrders,
    // 标准单详情
    ...lan_standardOrderDetail,
    // 预拼单列表
    ...lan_bulkOrderList,
    // 拼单结算
    ...lan_bulkOrderCheckout,
    // 文件库
    ...lan_fileLibrary,
    // 资源库设置
    ...lan_pcResourceSetting,
    // Sample Order列表
    ...lan_orders,
    ...lan_ordersDetail,
    ...lan_returns,
    ...lan_returnRequest,
    ...lan_returnDetail,
    // dashBoard用户指引
    ...lan_dashboardGuide,
    // 拼单页面
    ...lan_combineOrder
}

export { language }